var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ul",
    { class: _vm.noStyle ? "list-unstyled" : "list" },
    _vm._l(_vm.texts.length, function (index) {
      return _c("li", {
        key: _vm.texts[index - 1],
        class: _vm.additionalListClasses,
        attrs: { id: index },
        domProps: { innerHTML: _vm._s(_vm.texts[index - 1]) },
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }